<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Impostazioni</h1>
            </div>
        </div>
    </div>

    <div class="row mb-2">
        <div class="col">
            <form>
                <div class="row">
                    <div class="col-md-3 col-sm-6 form-group">
                        <label for="application_name">Nome applicativo</label>
                        <input type="text" class="form-control" id="application_name" name="application_name" placeholder="Nome" [(ngModel)]="getSettings().applicationName">
                    </div>
                    <div class="col-md-3 col-sm-6 form-group">
                        <label for="server_smtp">Server smtp</label>
                        <input type="text" class="form-control" id="server_smtp" name="server_smtp" placeholder="Server" [(ngModel)]="getSettings().server_smtp">
                    </div>
                    <div class="col-md-3 col-sm-6 form-group">
                        <label for="username_smtp">Username smtp</label>
                        <input type="text" class="form-control" id="username_smtp" name="username_smtp" placeholder="Username" [(ngModel)]="getSettings().username_smtp">
                    </div>
                    <div class="col-md-3 col-sm-6 form-group">
                        <label for="password_smtp">Password smtp</label>
                        <input type="text" class="form-control" id="password_smtp" name="password_smtp" placeholder="Password" [(ngModel)]="getSettings().password_smtp">
                    </div>
                    <div class="col-md-3 col-sm-6 form-group">
                        <label for="porta_smtp">Porta smtp</label>
                        <input type="number" class="form-control" id="porta_smtp" name="porta_smtp" placeholder="465" [(ngModel)]="getSettings().porta_smtp">
                    </div>
                    <div class="col-md-3 col-sm-6 form-group">
                        <label for="sicurezza_smtp">Sicurezza smtp</label>
                        <select class="form-control" name="sicurezza_smtp" id="sicurezza_smtp" [(ngModel)]="getSettings().secure_smtp">
                            <option value="ssl">SSL</option>
                            <option value="tls">TLS</option>
                            <option value="">Nessuna</option>
                        </select>
                    </div>
                    <div class="form-check col-md-3 col-sm-6 d-flex flex-column" style="justify-content: space-evenly; flex-direction: column;">
                        <input type="checkbox" class="form-check-input" id="coming_soon" [(ngModel)]="getSettings().coming_soon" name="coming_soon">
                        <label class="form-check-label" for="coming_soon">Coming soon</label>
                    </div>
                    <div class="form-check col-md-3 col-sm-6 d-flex flex-column" style="justify-content: space-evenly; flex-direction: column;">
                        <input type="checkbox" class="form-check-input" name="register_enable" id="register_enable" [(ngModel)]="window.usher.getPublicConfiguration().register_enable">
                        <label class="form-check-label" for="register_enable">Registrazione in App</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 form-group">
                        <label for="client_id">Client ID PayPal</label>
                        <input type="text" class="form-control" id="client_id" name="client_id" placeholder="Client ID" [(ngModel)]="getSettings().client_id">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 form-group">
                        <label for="client_secret">Client Secret PayPal</label>
                        <input type="text" class="form-control" id="client_secret" name="client_secret" placeholder="Client Secret" [(ngModel)]="getSettings().client_secret">
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="form-group col-md-12">
                        <label for="termini_select">Termini & condizioni</label>
                        <select name="termini_select" id="termini_select" class="form-control" [(ngModel)]="window.usher.getPublicConfiguration().type_termini">
                            <option value="link">Link al documento</option>
                            <option value="testo">Testo scritto</option>
                        </select>
                    </div>
                    <div class="col-12 form-group" [hidden]="window.usher.getPublicConfiguration().type_termini != 'link'">
                        <label for="termini">Termini & condizioni</label>
                        <input type="text" class="form-control" id="termini" name="termini" placeholder="https://www..." [(ngModel)]="window.usher.getPublicConfiguration().termini">
                    </div>
                    <div class="col-12" [hidden]="window.usher.getPublicConfiguration().type_termini != 'testo'">
                        <ckeditor [editor]="Editor" [(ngModel)]="window.usher.getPublicConfiguration().termini_testo" name="termini_testo" id="termini_testo"></ckeditor>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="form-group col-md-12">
                        <label for="cookie_select">Cookie policy</label>
                        <select name="cookie_select" id="cookie_select" class="form-control" [(ngModel)]="window.usher.getPublicConfiguration().type_cookie">
                            <option value="link">Link al documento</option>
                            <option value="testo">Testo scritto</option>
                        </select>
                    </div>
                    <div class="col-12 form-group" [hidden]="window.usher.getPublicConfiguration().type_cookie != 'link'">
                        <label for="cookie">Cookie policy</label>
                        <input type="text" class="form-control" id="cookie" name="cookie" placeholder="https://www..." [(ngModel)]="window.usher.getPublicConfiguration().cookie">
                    </div>
                    <div class="col-12" [hidden]="window.usher.getPublicConfiguration().type_cookie != 'testo'">
                        <ckeditor [editor]="Editor2" [(ngModel)]="window.usher.getPublicConfiguration().cookie_testo" name="cookie_testo" id="cookie_testo"></ckeditor>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="form-group col-md-12">
                        <label for="privacy_select">Privacy policy</label>
                        <select name="privacy_select" id="privacy_select" class="form-control" [(ngModel)]="window.usher.getPublicConfiguration().type_privacy">
                            <option value="link">Link al documento</option>
                            <option value="testo">Testo scritto</option>
                        </select>
                    </div>
                    <div class="col-12 form-group" [hidden]="window.usher.getPublicConfiguration().type_privacy != 'link'">
                        <label for="policy">Privacy policy</label>
                        <input type="text" class="form-control" id="policy" name="policy" placeholder="https://www..." [(ngModel)]="window.usher.getPublicConfiguration().privacy">
                    </div>
                    <div class="col-12" [hidden]="window.usher.getPublicConfiguration().type_privacy != 'testo'">
                        <ckeditor [editor]="Editor3" [(ngModel)]="window.usher.getPublicConfiguration().privacy_testo" name="privacy_testo" id="privacy_testo"></ckeditor>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="form-group col-md-12">
                        <label for="note_legali_select">Note legali</label>
                        <select name="note_legali_select" id="note_legali_select" class="form-control" [(ngModel)]="window.usher.getPublicConfiguration().type_note_legali">
                            <option value="link">Link al documento</option>
                            <option value="testo">Testo scritto</option>
                        </select>
                    </div>
                    <div class="col-12 form-group" [hidden]="window.usher.getPublicConfiguration().type_note_legali != 'link'">
                        <label for="policy">Note legali</label>
                        <input type="text" class="form-control" id="policy" name="policy" placeholder="https://www..." [(ngModel)]="window.usher.getPublicConfiguration().note_legali">
                    </div>
                    <div class="col-12" [hidden]="window.usher.getPublicConfiguration().type_note_legali != 'testo'">
                        <ckeditor [editor]="Editor4" [(ngModel)]="window.usher.getPublicConfiguration().note_legali_testo" name="note_legali_testo" id="note_legali_testo"></ckeditor>
                    </div>
                </div>

                <button type="button" class="btn btn-primary" style="float: right;" (click)="update()">Aggiorna</button>

            </form>
            
        </div>
    </div>

    <div class="row mt-5">
        <div class="col">
            <div class="table-responsive-md">
                <table class="table">
                    <thead class="thead-primary">
                        <tr>
                            <th scope="col">Nome</th>
                            <th scope="col">Partecipanti</th>
                            <!--<th scope="col" class="text-center">Elimina</th>-->
                        </tr>
                    </thead>
                    <tbody id="check_user_wrapper">
                        <a class="table-row" 
                            *ngFor="let gruppo of window.usher.get()?.public_configuration?.groups; index as i"
                            [routerLink]="'/settings'" 
                            [queryParams]="changeQueryParam({'group-selected': gruppo.id})">
                            <td class="text-capitalize" scope="col">{{ gruppo.name }}</td>
                            <td scope="col">{{ getGroupCount(gruppo) }}</td>
                            <!--<td scope="col"><span class="cursor-pointer d-table m-auto" (click)="openDeleteGruppo()"><i class="fas fa-trash"></i></span></td>-->
                        </a>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <button type="button" class="btn btn-primary mt-2" style="float: right;" (click)="openGruppo()">Aggiungi</button>
</div>

<span id="gruppoModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Aggiungi</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeGruppo()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <input type="text" class="form-control" id="gruppo" name="gruppo" placeholder="Nome del gruppo" [(ngModel)]="getGruppo().name">
                        </div>
                    </div>
                    <!--<div class="form-row">
                        <div class="form-group col-md-12 mb-2">
                            <label for="documenti_gruppo">Inserisci dei documenti del gruppo</label>
                            <input type="file" class="form-control" id="documenti_gruppo" name="documenti_gruppo" multiple (change)="getGroupDocuments($event)">
                        </div>
                    </div>-->
                </form>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="addGruppo()" [hidden]="!!getGruppo().id">Aggiungi</button>
              <button type="button" class="btn btn-primary" (click)="updateGruppo()" [hidden]="!getGruppo().id">Aggiorna</button>
              <button type="button" class="btn btn-danger" (click)="openDeleteGruppo()" [hidden]="!getGruppo().id">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeGruppo()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="deleteGruppoModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Elimina</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDeleteGruppo()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                Sei sicuro di voler eliminare questo gruppo? Tutti gli utenti appartenenti ad esso perderrano la referenza a questo gruppo.
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="deleteGruppo()">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeDeleteGruppo()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>